module.exports = function getResource(label, vars = []) {
    let resources = {
        curbsidePickupAvailable: 'Curbside Pickup Available'
    };

    return resources[label];
};
